import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {

    // --- Main card slider (normal slide) ---
    document.querySelectorAll('.leadership-swiper').forEach(function(swiperEl) {
        new Swiper(swiperEl, {
            slidesPerView: 4,
            spaceBetween: 31,
            navigation: {
                nextEl: swiperEl.parentElement.querySelector('.lp-arrow-next'),
                prevEl: swiperEl.parentElement.querySelector('.lp-arrow-prev'),
            },
            breakpoints: {
                320: { slidesPerView: 1, autoHeight: true },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
            },
        });
    });

    // --- Popup slider (fade effect) ---
    document.querySelectorAll('.leadership-promo').forEach(section => {

        const popupContainer = section.querySelector('.lp-popups');
        const popupSliderEl = section.querySelector('.lp-popup-slider');

        if (!popupSliderEl) {return;}

        // Initialize popup swiper with fade effect
        const popupSwiper = new Swiper(popupSliderEl, {
            slidesPerView: 1,
            autoHeight: true,
            loop: false,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            navigation: {
                nextEl: section.querySelector('.lp-popup-next'),
                prevEl: section.querySelector('.lp-popup-prev'),
            },
            on: {
                init: function() {
                    updateArrowState(this);
                },
                slideChange: function() {
                    updateArrowState(this);
                },
            },
        });

        // --- Open popup ---
        section.querySelectorAll('.lp-innerwrap[data-popup-id]').forEach(innerwrap => {
            innerwrap.addEventListener('click', function() {
                const popupId = this.dataset.popupId;
                popupContainer.style.display = 'block';
                document.body.classList.add('hide-scrollbar');

                const slides = popupSliderEl.querySelectorAll('.swiper-slide');
                const startIndex = Array.from(slides).findIndex(s => s.dataset.popupId === popupId);

                popupSwiper.slideTo(startIndex, 0); // instant move

                // Ensure arrow states update correctly
                setTimeout(() => {
                    updateArrowState(popupSwiper);
                }, 60);
            });
        });

        // --- Close popup ---
        popupContainer.querySelectorAll('.popup-close').forEach(btn => {
            btn.addEventListener('click', () => {
                popupContainer.style.display = 'none';
                document.body.classList.remove('hide-scrollbar');
            });
        });

        // --- Inside buttons (.ts-arrows) ---
        popupSliderEl.querySelectorAll('.ts-arrows').forEach(arrowWrap => {
            const nextBtn = arrowWrap.querySelector('.ts-arrow-next');
            const prevBtn = arrowWrap.querySelector('.ts-arrow-prev');

            if (nextBtn) {
                nextBtn.addEventListener('click', e => {
                    e.stopPropagation();
                    popupSwiper.slideNext();
                });
            }
            if (prevBtn) {
                prevBtn.addEventListener('click', e => {
                    e.stopPropagation();
                    popupSwiper.slidePrev();
                });
            }
        });

        // --- Function to handle arrow state ---
        function updateArrowState(swiper) {
            const prevButtons = popupSliderEl.querySelectorAll('.ts-arrow-prev, .lp-popup-prev');
            const nextButtons = popupSliderEl.querySelectorAll('.ts-arrow-next, .lp-popup-next');

            prevButtons.forEach(btn => {
                btn.classList.toggle('swiper-button-disabled', swiper.isBeginning);
            });

            nextButtons.forEach(btn => {
                btn.classList.toggle('swiper-button-disabled', swiper.isEnd);
            });
        }

    });

});
